import API from '@/api';
import { create } from '../../api/seasons';

const CREATE_SEASON = 'CREATE_SEASON';
const CREATE_SEASON_FAILED = 'CREATE_SEASON_FAILED';
const CREATE_SEASON_SUCCESS = 'CREATE_SEASON_SUCCESS';

const UPDATE_SEASON = 'UPDATE_SEASON';
const UPDATE_SEASON_FAILED = 'UPDATE_SEASON_FAILED';
const UPDATE_SEASON_SUCCESS = 'UPDATE_SEASON_SUCCESS';

const GET_SEASON = 'GET_SEASON';
const GET_SEASON_SUCCESS = 'GET_SEASON_SUCCESS';
const GET_SEASON_FAILED = 'GET_SEASON_FAILED';

const GET_CLUBHOUSE_SEASONS = 'GET_CLUBHOUSE_SEASONS';
const GET_CLUBHOUSE_SEASONS_SUCCESS = 'GET_CLUBHOUSE_SEASONS_SUCCESS';
const GET_CLUBHOUSE_SEASONS_FAILED = 'GET_CLUBHOUSE_SEASONS_FAILED';

const GET_USER_SEASONS = 'GET_USER_SEASONS';
const GET_USER_SEASONS_SUCCESS = 'GET_USER_SEASONS_SUCCESS';
const GET_USER_SEASONS_FAILED = 'GET_USER_SEASONS_FAILED';

const DELETE_SEASON = 'DELETE_SEASON';
const DELETE_SEASON_FAILED = 'DELETE_SEASON_FAILED';
const DELETE_SEASON_SUCCESS = 'DELETE_SEASON_SUCCESS';

const GET_SEASONS = 'GET_SEASONS';
const GET_SEASONS_SUCCESS = 'GET_SEASONS_SUCCESS';
const GET_SEASONS_FAILED = 'GET_SEASONS_FAILED';

const ADD_SEASON_EVENT = 'ADD_SEASON_EVENT';
const ADD_SEASON_EVENT_FAILED = 'ADD_SEASON_EVENT_FAILED';
const ADD_SEASON_EVENT_SUCCESS = 'ADD_SEASON_EVENT_SUCCESS';

const GET_SEASON_LEADERBOARD = 'GET_SEASON_LEADERBOARD';
const GET_SEASON_LEADERBOARD_SUCCESS = 'GET_SEASON_LEADERBOARD_SUCCESS';
const GET_SEASON_LEADERBOARD_FAILED = 'GET_SEASON_LEADERBOARD_FAILED';

const TOTAL_SEASONS = 'TOTAL_SEASONS';
const TOTAL_PARTICIPANTS = 'TOTAL_PARTICIPANTS';

const RESET_SEASON = 'RESET_SEASON';
const RESET_SEASONS = 'RESET_SEASONS';
const RESET_CLUBHOUSE_SEASONS = 'RESET_CLUBHOUSE_SEASONS';
const RESET_USER_SEASONS = 'RESET_USER_SEASONS';
const RESET_SEASON_LEADERBOARD = 'RESET_SEASON_LEADERBOARD';
const RESET_PARTICIPANTS = 'RESET_PARTICIPANTS';

// Enabled the module to be namespaced
const namespaced = true;

// Season Initial State
const state = {
  all: [],
  loading: false,
  season: {},
  clubhouseSeasons: [],
  userSeasons: [],
  totalSeasons: 0,
  seasonLeaderboard: [],
  loadingLeaderboard: false,
  participants: 0,
};

const emptyState = {
  all: [],
  loading: false,
  season: {},
  clubhouseSeasons: [],
  userSeasons: [],
  totalSeasons: 0,
  seasonLeaderboard: [],
  loadingLeaderboard: false,
  participants: 0,
};

// Season Getters
const getters = {
  loading: (state) => {
    return state.loading;
  },

  loadingLeaderboard: (state) => {
    return state.loadingLeaderboard;
  },

  list: (state) => {
    return state.all;
  },

  showSeason: (state) => {
    return state.season;
  },

  getClubhouseSeasons: (state) => {
    return state.clubhouseSeasons;
  },

  getUserSeasons: (state) => {
    return state.userSeasons;
  },

  getTotalSeasons: (state) => {
    return state.totalSeasons;
  },

  getSeasonLeaderboard: (state) => {
    return state.seasonLeaderboard;
  },

  getParticipants: (state) => {
    return state.participants;
  },
};

// Season actions
const actions = {
  //* list fetches the list of all seasons
  async list({ commit }) {
    let response;

    commit(GET_SEASONS);
    //* reset season list before fetching new seasons
    commit(RESET_SEASONS);

    try {
      response = await API.seasons.list();
    } catch (err) {
      response = err;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_SEASONS_FAILED);
        reject(response);
      } else {
        commit(GET_SEASONS_SUCCESS, response.data);
        // Return GET data within promise
        resolve(response.data);
      }
    }).catch((err) => {
      throw new Error(err);
    });
  },

  //* Get all clubhouse seasons
  async listClubhouseSeasons({ commit }, payload) {
    let response;

    commit(GET_CLUBHOUSE_SEASONS);
    //* reset season list before fetching new seasons
    commit(RESET_CLUBHOUSE_SEASONS);

    try {
      response = await API.seasons.listClubhouseSeasons(payload);

      if (
        !response ||
        response?.data === null ||
        response?.data === '' ||
        response?.data === undefined
      ) {
        commit(GET_CLUBHOUSE_SEASONS_FAILED);
        response = {
          data: [],
          status: 204,
          totalSeasons: 0,
        };
      }

      commit(TOTAL_SEASONS, response.totalSeasons);
    } catch (err) {
      response = err;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_CLUBHOUSE_SEASONS_FAILED);
        reject(response);
      } else {
        commit(GET_CLUBHOUSE_SEASONS_SUCCESS, response.data);
        // Return GET data within promise
        resolve(response.data);
      }
    }).catch((err) => {
      throw new Error(err);
    });
  },

  //* Get all clubhouse seasons
  async listUserSeasons({ commit, dispatch }, payload) {
    let response;

    commit(GET_USER_SEASONS);
    //* reset season list before fetching new seasons
    commit(RESET_USER_SEASONS);

    try {
      response = await API.seasons.listUserSeasons(payload);

      if (
        !response ||
        response?.data === null ||
        response?.data === '' ||
        response?.data === undefined
      ) {
        commit(GET_CLUBHOUSE_SEASONS_FAILED);
        response = {
          data: [],
          status: 204,
          totalSeasons: 0,
        };
      }

      const clubhouses = await dispatch('clubhouses/list', null, {
        root: true,
      });

      response.data = response?.data?.map((data) => {
        const clubhouse = clubhouses.find((club) => {
          return club.id === data.clubHouseID;
        });

        return { ...data, clubhouseName: clubhouse.name };
      });

      commit(TOTAL_SEASONS, response.totalSeasons);
    } catch (err) {
      response = err;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_USER_SEASONS_FAILED);
        reject(response);
      } else {
        // console.log('user response.data:', response.data);
        commit(GET_USER_SEASONS_SUCCESS, response.data);
        // Return GET data within promise
        resolve(response.data);
      }
    }).catch((err) => {
      throw new Error(err);
    });
  },

  //* create a season from the given payload
  async create({ commit }, payload) {
    let response = {};

    commit(CREATE_SEASON);

    try {
      response = await API.seasons.create(payload);

      return new Promise((resolve, reject) => {
        if (response.status >= 400) {
          commit(CREATE_SEASON_FAILED);
          reject(response);
        } else {
          commit(CREATE_SEASON_SUCCESS, response.data);
          resolve(response);
        }
      });
    } catch (err) {
      return new Promise((resolve, reject) => {
        commit(CREATE_SEASON_FAILED);
        reject(err);
      });
    }
  },

  //* show fetches the event details for given id from the API
  async show({ commit }, id) {
    let response = {};
    let eventResponse = {};

    commit(GET_SEASON);
    commit(RESET_SEASON);

    try {
      response = await API.seasons.show(id);

      if (response.status >= 400) {
        throw new Error();
      }

      if (response?.data) {
        eventResponse = await Promise.all(
          response.data?.events?.map(async (event) => {
            if (event) {
              const eventDetails = await API.events.show(event);
              return {
                eventID: eventDetails?.data?.id,
                eventName: eventDetails?.data?.name,
                eventPlayerCount: eventDetails?.data?.playerCount,
                gameMode: eventDetails?.data?.gameMode?.toLowerCase(),
              };
              // return eventDetails.data; //* Full event details
            }
          })
        );
      }

      response.data.eventDetails = eventResponse;
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400 || response.status === 0) {
        commit(GET_SEASON_FAILED);
        reject(response);
      }

      commit(GET_SEASON_SUCCESS, response.data);
      resolve(response.data);
    });
  },

  //* update a season
  async updateSeason({ commit }, payload) {
    let response = {};

    commit(UPDATE_SEASON);

    try {
      response = await API.seasons.update(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400 || response.status === 0) {
        commit(UPDATE_SEASON_FAILED);
        reject(response);
      }

      commit(UPDATE_SEASON_SUCCESS, response.data);
      resolve(response.data);
    });
  },

  //* delete a season
  async deleteSeason({ commit }, payload) {
    let response;

    commit(DELETE_SEASON);

    try {
      response = await API.seasons.deleteSeason(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400 || response.status === 0) {
        commit(DELETE_SEASON_FAILED);
        reject(response);
      }

      commit(DELETE_SEASON_SUCCESS, response.data);
      resolve(response.data);
    });
  },

  //* Add an event to a season
  async addSeasonEvent({ commit }, payload) {
    let response;

    commit(ADD_SEASON_EVENT);

    try {
      response = await API.seasons.addSeasonEvent(payload);
      console.log('response:', response);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400 || response.status === 0) {
        commit(ADD_SEASON_EVENT_FAILED);
        reject(response);
      }

      commit(ADD_SEASON_EVENT_SUCCESS, response.data);
      resolve(response.data);
    });
  },

  //* leaderboard fetches the leaderboard for an season by season id
  async leaderboard({ commit }, id) {
    let response = {};

    commit(GET_SEASON_LEADERBOARD);

    //* reset leaderboard stats
    commit(RESET_SEASON_LEADERBOARD);
    commit(RESET_PARTICIPANTS);

    try {
      response = await API.seasons.leaderboard(id);

      if (
        !response ||
        response?.data === null ||
        response?.data === '' ||
        response?.data === undefined
      ) {
        commit(GET_SEASON_LEADERBOARD_FAILED);
        response = {
          data: [],
          status: 204,
          participants: 0,
        };
      }

      commit(TOTAL_PARTICIPANTS, response.participants);

      return new Promise((resolve, reject) => {
        if (response.status >= 400 || response.status === 0) {
          commit(GET_SEASON_LEADERBOARD_FAILED);
          reject(response);
        } else {
          commit(GET_SEASON_LEADERBOARD_SUCCESS, response.data);
          resolve(response);
        }
      });
    } catch (err) {
      return new Promise((resolve, reject) => {
        commit(GET_SEASON_LEADERBOARD_FAILED);
        reject(err);
      });
    }
  },
};

// Season mutations
const mutations = {
  [CREATE_SEASON](state) {
    state.loading = true;
  },

  [CREATE_SEASON_FAILED](state, season) {
    state.season = season;
    state.loading = false;
  },

  [CREATE_SEASON_SUCCESS](state) {
    state.loading = false;
  },

  [GET_SEASON](state) {
    state.loading = true;
  },

  [GET_SEASON_SUCCESS](state, season) {
    state.season = season;
    state.loading = false;
  },

  [GET_SEASON_FAILED](state) {
    state.loading = false;
  },

  [UPDATE_SEASON](state) {
    state.loading = true;
  },

  [UPDATE_SEASON_FAILED](state, season) {
    state.season = season;
    state.loading = false;
  },

  [UPDATE_SEASON_SUCCESS](state) {
    state.loading = false;
  },

  [DELETE_SEASON](state) {
    state.loading = true;
  },

  [DELETE_SEASON_FAILED](state, payload) {
    state.seasons = state.seasons.filter((season) => {
      return season.id !== payload.id;
    });
    state.loading = false;
  },

  [DELETE_SEASON_SUCCESS](state) {
    state.loading = false;
  },

  [ADD_SEASON_EVENT](state) {
    state.loading = true;
  },

  [ADD_SEASON_EVENT_FAILED](state) {
    state.loading = false;
  },

  [ADD_SEASON_EVENT_SUCCESS](state) {
    state.loading = false;
  },

  [GET_SEASONS](state) {
    state.loading = true;
  },

  [GET_SEASONS_SUCCESS](state, seasons) {
    state.all = seasons;
    state.loading = false;
  },

  [GET_SEASONS_FAILED](state) {
    state.loading = false;
  },

  [GET_CLUBHOUSE_SEASONS](state) {
    state.loading = true;
  },

  [GET_CLUBHOUSE_SEASONS_SUCCESS](state, seasons) {
    state.clubhouseSeasons = seasons;
    state.loading = false;
  },

  [GET_CLUBHOUSE_SEASONS_FAILED](state) {
    state.loading = false;
  },

  [GET_USER_SEASONS](state) {
    state.loading = true;
  },

  [GET_USER_SEASONS_SUCCESS](state, seasons) {
    state.userSeasons = seasons;
    state.loading = false;
  },

  [GET_USER_SEASONS_FAILED](state) {
    state.loading = false;
  },

  [GET_SEASON_LEADERBOARD](state) {
    state.loadingLeaderboard = true;
  },

  [GET_SEASON_LEADERBOARD_SUCCESS](state, leaderboard) {
    state.seasonLeaderboard = leaderboard;
    state.loadingLeaderboard = false;
  },

  [GET_SEASON_LEADERBOARD_FAILED](state) {
    state.seasonLeaderboard = [];
    state.loadingLeaderboard = false;
  },

  [TOTAL_SEASONS](state, payload) {
    state.totalSeasons = payload;
  },

  [TOTAL_PARTICIPANTS](state, payload) {
    state.participants = payload;
  },

  [RESET_SEASON](state) {
    state.season = {};
  },

  [RESET_SEASONS](state) {
    state.all = [];
  },

  [RESET_CLUBHOUSE_SEASONS](state) {
    state.clubhouseSeasons = [];
  },

  [RESET_USER_SEASONS](state) {
    state.userSeasons = [];
  },

  [RESET_SEASON_LEADERBOARD](state) {
    state.seasonLeaderboard = [];
  },

  [RESET_PARTICIPANTS](state) {
    state.participants = 0;
  },
};

export default {
  namespaced,
  state,
  actions,
  getters,
  mutations,
};
